// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//import VueFire from 'vuefire'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/auth'
// import { firebase } from '@firebase/app';
import 'firebase/firestore'
import 'firebase/functions'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {faLink,faCoffee, faCheck,faCheckCircle, faSpinner, faMinusCircle, faPlus,faPencilAlt, faChevronCircleUp, faChevronCircleDown, faCaretUp,faCaretDown, faEllipsisV} from '@fortawesome/free-solid-svg-icons'
import {faCircle, faCheckSquare, faSquare, faEdit, faComment, faQuestionCircle,faSmile, faFrownOpen, faGrimace, faAngry, faMehRollingEyes, faClock, faTrashAlt, faCaretSquareUp, faCaretSquareDown, faWindowClose,faExternalLink} from '@fortawesome/free-regular-svg-icons'
// import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import ICS from 'vue-ics'
import VueGAPI from "vue-gapi"
import VueTagsInput from '@johmun/vue-tags-input'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import VueHtml2Canvas from 'vue-html2canvas'
import regeneratorRuntime from "regenerator-runtime"
Vue.use(VueHtml2Canvas)

Vue.component('tags-input', VoerroTagsInput);
Vue.component('vue-tags-input', VueTagsInput)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component('v-select',vSelect)
Vue.component('multiselect', Multiselect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.use(firestorePlugin)
Vue.use(ICS, {uidDomain: 'moogenda.com',prodId: 'Moogenda'})

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

// Register components in your 'main.js'
Vue.component('calendar', Calendar)
Vue.component('v-date-picker', DatePicker)


firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN
})
console.log(process.env.CONFIG_FB_API_KEY)
//firebase.initializeApp(process.env.firebaseConfig)
firebase.firestore().settings({ timestampsInSnapshots: true })

/*  Setup Firebase Functions  */
var functions = firebase.functions()
// console.log('process.env.NODE_ENV:' + process.env.NODE_ENV)
console.log('process.env.VUE_APP_ENV_TITLE:' + process.env.VUE_APP_ENV_TITLE)
// if (process.env.NODE_ENV === 'development') {
if (process.env.VUE_APP_ENV_TITLE === 'development') {
  var port = 5000
  console.info('Using local functions emulator on port:' + port)
  functions.useFunctionsEmulator('http://localhost:' + port)
}

/*  Setup Google API */
const apiConfig = {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile',
  discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"],
  prompt: 'select_account'
}

Vue.use(VueGAPI, apiConfig)

export const db = firebase.firestore()
export {router}
export {FontAwesomeIcon, FontAwesomeLayers}
export {firebase}
export {functions}
export {VueBootstrapTypeahead}
export {DatePicker}


// Vue.config.productionTip = false
//Vue.use(VueFire)
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))
// Vue.component('font-awesome-icon', FontAwesomeIcon)
//faExternalLink
library.add( faWindowClose, faLink, faEllipsisV, faCircle, faEdit, faCoffee, faComment, faSmile, faSpinner, faQuestionCircle, faCheck, faFrownOpen, faMinusCircle, faGrimace, faAngry, faMehRollingEyes, faPlus, faCheckSquare, faSquare, faClock, faTrashAlt,faPencilAlt, faChevronCircleUp, faChevronCircleDown,faCaretSquareUp, faCaretSquareDown,faCaretUp,faCaretDown,faCheckCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
// Vue.component('font-awesome-layers', FontAwesomeLayers)


let app = ''
/* eslint-disable no-new */
firebase.auth().onAuthStateChanged(function (user) {

  // Identify user to Hubspot Tracking code
  if (user) {
    mixpanel.identify(user.email)
    mixpanel.people.set({'$email': user.email })
    console.log('Mixpanel id done')

    // var _hsq = window._hsq = window._hsq || []
     var _hsq = window._hsq
    _hsq.push(["identify",{
        email: user.email
    }])
    _hsq.push(["trackEvent", {
        id: "396229"
    }])
  }
  // Initialise Google API Web client
    // setTimeout(
    //   gapi.load('client', () => {
    //   gapi.client.init({
    //     // 'apiKey': 'AIzaSyBAiR9o389TTDa-QQ1Ex8w9_vEG9jmP2CU',
    //     'apiKey': 'AIzaSyD1XKxUUhvqFLw5Z4Yvv_9N7BiSN6quSlA',
    //     'discoveryDocs': ['https://people.googleapis.com/$discovery/rest'],
    //     // 'clientId': '403823427630-otfqnbq0bs21fgnugf07tgb28fv85rpl.apps.googleusercontent.com',
    //     'clientId': '620730757588-cp2ga6k7018o1ok1jo2p6tkdn8p0e4do.apps.googleusercontent.com',
    //     // 'scope': 'https://www.googleapis.com/auth/contacts.readonly',
        // 'scope': 'https://www.google.com/m8/feeds',
    //     }).then( (result) =>{
    //       debugger
    //     })
    //   })
    // ,50000)

  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App v-bind:user="user" v-bind:userData="userData" />',
      data: {
        user: user,
        userData: {}
      }
    })
  } else {
    app.user = user
  }
})
